import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';

import configuration from 'configs/configuration';

class SignalRService {
  private connection: signalR.HubConnection | null = null;

  private connectionReady: Promise<void> | null = null;

  private pendingHandlers: Array<Parameters<SignalRService['on']>> = [];

  constructor(private hubPath: string) {}

  public async start(token?: string) {
    if (this.connectionReady) return this.connectionReady;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(`${configuration.apiUrl}${this.hubPath}`, {
        accessTokenFactory: () => token || '',
        transport: HttpTransportType.ServerSentEvents,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.pendingHandlers.forEach(([event, callback]) => this.connection?.on(event, callback));
    this.pendingHandlers = [];

    this.RegisterCoreEvents();

    this.connectionReady = (async () => {
      try {
        await this.connection?.start();
        console.log('✅ SignalR connected!');
      } catch (error) {
        console.error('SignalR connection error:', error);
      }
    })();

    return this.connectionReady;
  }

  private RegisterCoreEvents = () => {
    if (!this.connection) return;

    this.connection.onreconnecting(() => {
      console.warn('SignalR reconnecting...');
    });

    this.connection.onreconnected(() => {
      console.warn('SignalR reconnected!');
    });

    this.connection.onclose(() => {
      console.warn('SignalR closed!');
    });
  };

  public on = (event: string, callback: (...args: any[]) => void) => {
    if (this.connection) {
      this.connection.on(event, callback);
    } else {
      this.pendingHandlers.push([event, callback]);
    }
  };

  public off = (event: string, callback: (...args: any[]) => void) => {
    if (this.connection) {
      this.connection.off(event, callback);
    } else {
      this.pendingHandlers = this.pendingHandlers.filter(([, cb]) => cb !== callback);
    }
  };

  public async invoke(method: string, ...args: any[]) {
    return this.connection?.invoke(method, ...args);
  }

  public async stop() {
    await this.connection?.stop();
    this.connection = null;
    this.connectionReady = null;
  }
}

export const signalRService = new SignalRService('notifications');
export const messagingSignalRService = new SignalRService('chat');
